<template>
    <b-row v-bind:class="{'run-loading': models.loading}">
        <b-col md="12 mt-2 mb-3">
            <gofix-button label="New Inventory Set" @click="openModalNewInventory" outline></gofix-button>
        </b-col>
        <b-col md="12" v-for="(inventory, index) in InventoryItems" :key="index">
            <RoomInventory :reloadInventory="reloadInventory" :deleteSet= "deleteSet" :fields="fields" :item="inventory"></RoomInventory>
        </b-col>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Create New Inventory Set" hide-footer :centered="true" v-model="models.open" refs="modal-Create">
            <b-form class="pb-20">
                <gofix-form-dropdown
                        label="Location Type"
                        :options="selectLocationTypesOptions"
                        v-model="models.room_inventory.location_type"
                        vLabel="reference_value_text">
                </gofix-form-dropdown>
                <gofix-form-dropdown
                        label="Category"
                        :options="selectPropertyCategoryOptions"
                        v-model="models.room_inventory.category"
                        class="pt-1"
                        vLabel="reference_value_text">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="CANCEL" @click="models.open = false" noBorder dark></gofix-button>
                <gofix-button label="OK" @click="checkRoomInventorySet" :loading="models.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" ref="modal-check">
            <div class="center" v-bind:style="{ paddingBottom: '22px', paddingTop: '22px'}">Are you sure you want to remove the<br/>inherited inventory set and create<br/>a new set for this unit?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="$refs['modal-check'].hide()">No</b-button>
                <b-button class="custom-btn" @click="createRoomInventorySet" >Yes</b-button>
            </b-button-group>
        </b-modal>
    </b-row>
</template>
<script>
    import RoomInventory from "./c-room-inventory"
    export default {
        name: 'property_inventory',
        components: {
            RoomInventory
        },
        props:["property_id", "location_type_id", "room_category_id", "type", "selectPropertyCategoryOptions", "selectLocationTypesOptions", "inventorySetOptions"],
        data () {
            return {
                InventoryItems: [],
                table_name: "client-contract-property-inventory",
                fields: { fields: []},
                models: {
                    open: false,
                    loading: false,
                    room_inventory:{
                        id: null,
                        category: null,
                        location_type: null
                    }
                },
            }
        },
        watch: {
            property_id: function(val){
                this.getListRoomInventory();
            }
        },
        created(){

            this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', {
                user_id: 0,
                table_name: this.table_name
            }).then(response => {
                var columnSettings = response.data.data;
                var tmpShow =  columnSettings.settings.fields.filter(item => item.isActive == 1).sort((a,b) => a.sequence > b.sequence)

                tmpShow.forEach((obj) => {
                    // set filter
                    if(obj.filter.active){
                        obj.isFilter = true
                    }else{
                        obj.isFilter = false
                    }
                })
                this.fields.fields = tmpShow
            })
        },
        methods:{
            reloadInventory(){
                this.getListRoomInventory();
            },
            getListRoomInventory(){
                if(this.fields && this.fields.fields.length > 0){
                    var valObj = this.fields.fields.filter(function(item){
                        if(item.default_sorting !== "off") return item;
                    });
                }
                let params = {
                    property_id: this.property_id,
                    sortColumn: (valObj && valObj.length > 0) ? valObj[0].key:'id',
                    sortDirection: (valObj && valObj.length > 0) ? valObj[0].default_sorting : 'desc'
                }
                this.models.loading = true
                this.$store.dispatch("PropertyController/getListRoomInventory", params)
                    .then(response => {
                        this.models.loading = false;
                        this.InventoryItems = response.data.data.items;
                    })
            },
            deleteSet(item){
                this.$store.dispatch("PropertyController/deleteRoomInventorySet", {ids: [item.id]})
                    .then(response => {
                        this.getListRoomInventory();
                        this.$alertNotification(this.$notificationV2('deleting', 'room_inventory_set'));
                    })
            },
            openModalNewInventory(){
                if(!this.property_id){
                    return this.$alertNotification("Please select property!", "danger");
                }
                this.models.open=true
            },
            checkRoomInventorySet(){
                if(!this.models.room_inventory.location_type){
                    return this.$alertNotification("Location Type is required", "danger");
                }

                if(!this.models.room_inventory.category){
                    return this.$alertNotification("Category is required", "danger");
                }
                let params = {
                    property_id: this.property_id,
                    location_type_id: this.models.room_inventory.location_type.id,
                    room_category_id: this.models.room_inventory.category.id,
                    set_name: this.models.room_inventory.location_type.reference_value_text + " - " + this.models.room_inventory.category.reference_value_text
                }
                this.$store.dispatch("PropertyController/checkNewRoomInventorySet", params)
                    .then(response => {
                        this.createRoomInventorySet()
                    }).catch((err) => {
                    this.models.open = false
                    if(err.response.data.status === 400 && err.response.data.error.code === 400){
                        return this.$alertNotification("Inventory set already exists", "danger");
                    }
                    this.$refs['modal-check'].show()
                })
            },
            createRoomInventorySet(){
                if(!this.models.room_inventory.location_type){
                    return this.$alertNotification("Location Type is required", "danger");
                }

                if(!this.models.room_inventory.category){
                    return this.$alertNotification("Category is required", "danger");
                }
                let params = {
                    property_id: this.property_id,
                    location_type_id: this.models.room_inventory.location_type.id,
                    room_category_id: this.models.room_inventory.category.id,
                    set_name: this.models.room_inventory.location_type.reference_value_text + " - " + this.models.room_inventory.category.reference_value_text
                }
                this.$store.dispatch("PropertyController/createNewRoomInventorySet", params)
                    .then(response => {
                        this.models.open = false
                        this.$refs['modal-check'].hide()
                        this.getListRoomInventory();
                        this.$alertNotification(this.$notificationV2('adding', 'room_inventory_set'));
                    }).catch((err) => {
                        this.models.open = false
                        this.$refs['modal-check'].hide();
                    })
            }
        }
    }
</script>
